import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a18f728a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-8" }
const _hoisted_2 = { class: "title mb-2" }

import Currency from '@/popup/components/views/Home/Settings/Localization/Currency.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'Localization',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('settings.currency.title')), 1 /* TEXT */),
    _createVNode(Currency)
  ]))
}
}

})